__turbopack_context__.v({
  "articleCard": "ArticleCard-module__nuuL6G__articleCard",
  "content": "ArticleCard-module__nuuL6G__content",
  "imageContainer": "ArticleCard-module__nuuL6G__imageContainer",
  "imageLink": "ArticleCard-module__nuuL6G__imageLink",
  "title": "ArticleCard-module__nuuL6G__title",
});
